import DineroFactory from 'dinero.js'

export interface QuantityEntitlement {
    quantity: number | null
    unlimited: boolean
}

export class BillingDetails {

    public price: string

    constructor(
        public inService: boolean,
        public needsToUpgradeTrial: boolean,
        public nextBillingPeriod: 'MONTHLY' | 'ANNUALLY',
        public nextBillingAmount: string,
        public nextBillingAmountCurrencyCode: string,
        public nextBillingDate: Date | null,
        public addons: string[],
        public entitlements: string[] = [],
        public quantityEntitlements: Record<string, QuantityEntitlement> = {}
    ) {
        this.entitlements = Array.from(new Set(
            this.entitlements.map(entitlement => BillingDetails.normalizeEntitlementName(entitlement))
        ))
        this.quantityEntitlements = Object.fromEntries(
            Object.entries(this.quantityEntitlements)
                .map(([entitlement, value]) => [
                    BillingDetails.normalizeEntitlementName(entitlement),
                    { ...value },
                ])
        )
        this.price = DineroFactory({
            amount: parseInt(this.nextBillingAmount),
            currency: this.nextBillingAmountCurrencyCode as any,
        }).toFormat()
    }

    hasOrdersAddon(): boolean {
        return this.addons.includes("orders")
    }

    hasVouchersAddon(): boolean {
        return this.addons.includes("vouchers")
    }

    hasEntitlement(entitlement: string): boolean {
        return this.entitlements.includes(BillingDetails.normalizeEntitlementName(entitlement))
    }

    hasEntitlementCapacity(entitlement: string, currentUsage: number | null | undefined): boolean {
        if (typeof currentUsage !== 'number' || !Number.isInteger(currentUsage) || currentUsage < 0) {
            return false
        }
        const quantityEntitlement = this.quantityEntitlements[
            BillingDetails.normalizeEntitlementName(entitlement)
        ]
        if (quantityEntitlement === undefined) {
            return false
        }
        if (quantityEntitlement.unlimited) {
            return true
        }
        const quantity = quantityEntitlement.quantity
        return typeof quantity === 'number'
            && Number.isInteger(quantity)
            && quantity >= 0
            && currentUsage < quantity
    }

    private static normalizeEntitlementName(entitlement: string): string {
        return entitlement.trim().toLowerCase().replace(/\s+/g, '-')
    }
}
